// extracted by mini-css-extract-plugin
export default {"buttons":"Various_buttons__H0DNf","buttonContainer":"Various_buttonContainer__NwdY6"};